import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const MissionVision = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });

  const values = [
    {
      icon: 'ri-focus-3-line',
      title: 'Odaklanma',
      description: 'Sadece sigorta sektörüne odaklanarak derin uzmanlık kazandık.'
    },
    {
      icon: 'ri-lightbulb-flash-line',
      title: 'İnovasyon',
      description: 'Sürekli yenilikçi çözümler geliştirerek sektöre öncülük ediyoruz.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Güvenilirlik',
      description: '120+ acente bize güveniyor ve uzun vadeli ortaklıklar kuruyoruz.'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Sonuç Odaklı',
      description: 'Her projede ölçülebilir sonuçlar ve sürdürülebilir büyüme hedefliyoruz.'
    }
  ];

  return (
    <section ref={ref} className="py-24 bg-gradient-to-b from-white to-gray-50 relative overflow-hidden">
      {/* Background Decoration */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#007dff]/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#0066dd]/5 rounded-full blur-3xl"></div>

      <div className="max-w-[1440px] mx-auto px-8 relative z-10">
        {/* About Us Text Section */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="max-w-5xl mx-auto mb-20"
        >
          <div className="text-center mb-8">
            <div className="inline-block bg-[#007dff]/10 px-6 py-2 rounded-full mb-4">
              <span className="font-poppins text-sm font-semibold text-[#007dff]">
                Hikayemiz
              </span>
            </div>
            <h2 className="font-poppins font-bold text-4xl lg:text-5xl text-gray-900 mb-6">
              Dijital Dönüşümün Öncüsü
            </h2>
          </div>
          
          <div className="bg-white rounded-3xl p-10 lg:p-12 shadow-xl border border-gray-100">
            <div className="space-y-6 text-gray-700 leading-relaxed">
              <p className="font-poppins text-[16px] lg:text-[17px]">
                2015 yılında, sigorta sektöründe dijital pazarlamanın henüz yeni keşfedildiği bir dönemde yola çıktık. 
                O günden bugüne, sadece bir dijital ajans olmaktan öte, sigorta acentelerinin en güvenilir büyüme ortağı 
                haline geldik. Sektöre olan derin tutkumuz ve uzmanlığımız, bizi bu alanda Türkiye'nin önde gelen 
                isimlerinden biri yaptı.
              </p>
              
              <p className="font-poppins text-[16px] lg:text-[17px]">
                Yıllar içinde 120'den fazla sigorta acentesiyle çalışma fırsatı bulduk. Her biri bizim için sadece bir 
                müşteri değil, uzun vadeli bir iş ortağı. Onların başarısı bizim başarımız, büyümeleri bizim motivasyonumuz. 
                Bu yolculukta edindiğimiz deneyim, sigorta sektörünün dinamiklerini, müşteri davranışlarını ve dijital 
                pazarlamanın inceliklerini derinlemesine anlamamızı sağladı.
              </p>
              
              <p className="font-poppins text-[16px] lg:text-[17px]">
                Bugün, sadece web sitesi tasarımı veya sosyal medya yönetimi sunmuyoruz. Acentelerin dijital ekosistemini 
                baştan sona kuruyor, CRM sistemlerinden dijital reklamlara, marka kimliğinden video prodüksiyonuna kadar 
                tüm süreçleri entegre bir şekilde yönetiyoruz. Her proje, sektörel bilgimiz ve veri odaklı yaklaşımımızla 
                şekilleniyor. Amacımız, acentelerin sadece dijital varlık oluşturması değil, ölçülebilir sonuçlar alması 
                ve sürdürülebilir büyüme kaydetmesi.
              </p>
              
              <p className="font-poppins text-[16px] lg:text-[17px]">
                Ekibimiz, dijital pazarlama uzmanları, kreatif tasarımcılar, yazılım geliştiriciler ve sigorta sektörü 
                danışmanlarından oluşuyor. Bu çok yönlü yapı, müşterilerimize 360 derece hizmet sunmamızı sağlıyor. 
                Teknolojiye olan hakimiyetimiz kadar, sigorta sektörünün dilini konuşabilmemiz de bizi farklı kılıyor. 
                Müşterilerimizin ihtiyaçlarını anlamak için onların dünyasına giriyoruz.
              </p>
              
              <p className="font-poppins text-[16px] lg:text-[17px]">
                Geleceğe baktığımızda, vizyonumuz net: Türkiye'deki her sigorta acentesinin dijital büyüme yolculuğunda 
                ilk tercihi olmak. Yapay zeka, otomasyon ve veri analitiği gibi yeni teknolojileri sektöre entegre ederek, 
                acentelerin rekabet avantajı elde etmesini sağlamak. Çünkü biz, sigorta sektörünün dijital geleceğine 
                inanıyoruz ve bu geleceği birlikte inşa ediyoruz.
              </p>
            </div>
            
            {/* Stats */}
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 mt-12 pt-10 border-t border-gray-200">
              <div className="text-center">
                <div className="font-poppins font-bold text-4xl text-[#007dff] mb-2">9+</div>
                <div className="font-poppins text-sm text-gray-600">Yıllık Deneyim</div>
              </div>
              <div className="text-center">
                <div className="font-poppins font-bold text-4xl text-[#007dff] mb-2">120+</div>
                <div className="font-poppins text-sm text-gray-600">Mutlu Acente</div>
              </div>
              <div className="text-center">
                <div className="font-poppins font-bold text-4xl text-[#007dff] mb-2">500+</div>
                <div className="font-poppins text-sm text-gray-600">Tamamlanan Proje</div>
              </div>
              <div className="text-center">
                <div className="font-poppins font-bold text-4xl text-[#007dff] mb-2">%98</div>
                <div className="font-poppins text-sm text-gray-600">Müşteri Memnuniyeti</div>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <div className="inline-block bg-[#007dff]/10 px-6 py-2 rounded-full mb-4">
            <span className="font-poppins text-sm font-semibold text-[#007dff]">
              Değerlerimiz & Hedeflerimiz
            </span>
          </div>
          <h2 className="font-poppins font-bold text-4xl lg:text-5xl text-gray-900 mb-4">
            Bizi Biz Yapan Değerler
          </h2>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-8 mb-16">
          {/* Mission */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.6 }}
            className="relative group"
          >
            <div className="absolute inset-0 bg-gradient-to-br from-[#007dff]/10 to-[#0066dd]/5 rounded-3xl transform group-hover:scale-105 transition-transform duration-500"></div>
            <div className="relative bg-white rounded-3xl p-10 border border-[#007dff]/20 shadow-lg hover:shadow-2xl transition-all duration-500">
              <div className="flex items-start gap-6 mb-6">
                <div className="w-20 h-20 flex items-center justify-center bg-gradient-to-br from-[#007dff] to-[#0066dd] rounded-2xl shadow-lg flex-shrink-0">
                  <i className="ri-compass-3-line text-4xl text-white"></i>
                </div>
                <div>
                  <h2 className="font-poppins font-bold text-3xl text-gray-900 mb-2">
                    Misyonumuz
                  </h2>
                  <div className="w-16 h-1 bg-gradient-to-r from-[#007dff] to-transparent rounded-full"></div>
                </div>
              </div>
              <p className="font-poppins text-[15px] text-gray-600 leading-relaxed mb-6">
                Sigorta acentelerinin dijital dünyada güçlü bir varlık oluşturmasını sağlamak, 
                müşteri portföylerini büyütmek ve sektörde fark yaratmalarına yardımcı olmak. 
                Her acentenin benzersiz ihtiyaçlarına özel, sonuç odaklı çözümler sunarak 
                dijital büyümelerini hızlandırmak.
              </p>
              <div className="flex items-center gap-2 text-[#007dff] font-poppins font-semibold text-sm">
                <span>Daha Fazla Bilgi</span>
                <i className="ri-arrow-right-line"></i>
              </div>
            </div>
          </motion.div>

          {/* Vision */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="relative group"
          >
            <div className="absolute inset-0 bg-gradient-to-br from-[#0066dd]/10 to-[#0052bb]/5 rounded-3xl transform group-hover:scale-105 transition-transform duration-500"></div>
            <div className="relative bg-white rounded-3xl p-10 border border-[#0066dd]/20 shadow-lg hover:shadow-2xl transition-all duration-500">
              <div className="flex items-start gap-6 mb-6">
                <div className="w-20 h-20 flex items-center justify-center bg-gradient-to-br from-[#0066dd] to-[#0052bb] rounded-2xl shadow-lg flex-shrink-0">
                  <i className="ri-eye-line text-4xl text-white"></i>
                </div>
                <div>
                  <h2 className="font-poppins font-bold text-3xl text-gray-900 mb-2">
                    Vizyonumuz
                  </h2>
                  <div className="w-16 h-1 bg-gradient-to-r from-[#0066dd] to-transparent rounded-full"></div>
                </div>
              </div>
              <p className="font-poppins text-[15px] text-gray-600 leading-relaxed mb-6">
                Türkiye'nin sigorta sektöründe dijital dönüşümün öncüsü ve lideri olmak. 
                Her sigorta acentesinin dijital büyüme yolculuğunda ilk tercihi haline gelmek. 
                Sektöre özel uzmanlığımız ve yenilikçi yaklaşımımızla, sigorta acentelerinin 
                dijital başarı hikayelerini yazmak.
              </p>
              <div className="flex items-center gap-2 text-[#0066dd] font-poppins font-semibold text-sm">
                <span>Daha Fazla Bilgi</span>
                <i className="ri-arrow-right-line"></i>
              </div>
            </div>
          </motion.div>
        </div>

        {/* Core Values Grid */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="grid md:grid-cols-2 lg:grid-cols-4 gap-6"
        >
          {values.map((value, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: 0.5 + index * 0.1 }}
              className="bg-white rounded-2xl p-6 border border-gray-200 hover:border-[#007dff]/50 hover:shadow-xl transition-all duration-300 group"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-[#007dff]/10 rounded-xl mb-4 group-hover:bg-[#007dff] transition-colors duration-300">
                <i className={`${value.icon} text-2xl text-[#007dff] group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <h3 className="font-poppins font-semibold text-lg text-gray-900 mb-2">
                {value.title}
              </h3>
              <p className="font-poppins text-sm text-gray-600 leading-relaxed">
                {value.description}
              </p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default MissionVision;
